// extracted by mini-css-extract-plugin
export default {"addyourown_splash":"addyourown_splash__ZsD5k","addyourownpad":"addyourownpad__ZVAeY","flip":"flip__RKSLx","illustration":"illustration__N3oZa"};